import React, { Component } from 'react';
import PropTypes from 'prop-types';
import TextHighlightIcon from './TextHighlightIcon.js';
import { TEXT_HIGHLIGHT_TYPE } from '../types.js';
import BaseTextColor from './BaseTextColor.js';
import { textBackgroundPredicate } from '../text-decorations-utils.js';
import { DEFAULT_HIGHLIGHT_COLOR } from '../constants.js';
import 'classnames';
import 'react-modal';
import 'wix-rich-content-common';
import 'wix-rich-content-editor-common';
import './TextColorPanel.js';
import 'wix-rich-content-plugin-commons';
import '../color-scheme-utils.js';
import 'lodash';

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
class TextHighlightButton extends Component {
  constructor(props) {
    super(props);
    this.buttonRef = React.createRef();
  }
  render() {
    var _a, _b;
    const settings = this.props.config[TEXT_HIGHLIGHT_TYPE];
    const iconTextHighlight = ((_b = (_a = settings == null ? void 0 : settings.toolbar) == null ? void 0 : _a.icons) == null ? void 0 : _b.InsertPluginButtonIcon) || TextHighlightIcon;
    const pluginParams = {
      dataHook: "TextHighlightButton",
      toolTip: "TextHighlightButton_Tooltip",
      icon: iconTextHighlight,
      type: TEXT_HIGHLIGHT_TYPE,
      predicate: textBackgroundPredicate,
      defaultColor: DEFAULT_HIGHLIGHT_COLOR,
      colorPickerHeaderKey: "Color_Picker_TextHighlightButton_Header"
    };
    return /* @__PURE__ */ React.createElement(BaseTextColor, __spreadValues({ buttonRef: this.buttonRef, pluginParams }, this.props));
  }
}
TextHighlightButton.propTypes = {
  getEditorState: PropTypes.func.isRequired,
  setEditorState: PropTypes.func.isRequired,
  onExtendContent: PropTypes.func.isRequired,
  onOverrideContent: PropTypes.func.isRequired,
  theme: PropTypes.object.isRequired,
  isMobile: PropTypes.bool,
  textColorModal: PropTypes.bool,
  helpers: PropTypes.object,
  keyName: PropTypes.string,
  anchorTarget: PropTypes.string,
  relValue: PropTypes.string,
  t: PropTypes.func,
  tabIndex: PropTypes.number,
  uiSettings: PropTypes.object,
  config: PropTypes.object,
  setKeepOpen: PropTypes.func
};
TextHighlightButton.defaultProps = {
  setKeepOpen: () => {
  }
};

export { TextHighlightButton as default };
//# sourceMappingURL=TextHighlightButton.js.map
